import { createRouter, createWebHistory } from 'vue-router'
import mainScreen from '../views/mainScreen.vue'
import Layout from "@/components/Layout.vue";
import MainPage from '../views/MainPage.vue'
import store from '../store/store.js'
// import Test from '../views/RegisterPage.vue'
const routes = [
    {
        path: '/',
        name: 'Layout',
        component: Layout,
        redirect: "/MainPage",
        children: [
            {
                path: '/MainPage',
                name: 'MainPage',
                component: MainPage,

            },
            {
                path: '/IntroductionPage',
                name: 'IntroductionPage',
                component: () => import("@/components/IntroductionPage.vue")
            },
            {
                path: '/AssociationPurpose',
                name: 'AssociationPurpose',
                component: () => import("@/components/AssociationPurpose.vue")
            },
            {
                path: '/VisionAndMission',
                name: 'VisionAndMission',
                component: () => import("@/components/VisionAndMission.vue")
            },
            {
                path: '/ConditionPage',
                name: 'ConditionPage',
                component: () => import("@/components/ConditionPage")
            },
            {
                path: 'BonusPage',
                name: 'BonusPage',
                component: () => import("@/components/BonusPage.vue")
            },
            {
                path: '/ActivityPage',
                name: 'ActivityPage',
                component: () => import("@/components/ActivityPage.vue")
            },
            {
                path: '/InternationalPage',
                name: 'InternationalPage',
                component: () => import("@/components/InternationalPage")
            },
            {
                path: '/ManagementPage',
                name: 'ManagementPage',
                component: () => import("@/components/ManagementPage")
            },
            {
                path: '/MienPage',
                name: 'MienPage',
                component: () => import("@/components/MienPage")
            },
            {
                path: 'MembershipPage',
                name: 'MembershipPage',
                component: () => import("@/components/MembershipPage.vue")
            },
            {
                path: '/AdministrationPage',
                name: 'AdministrationPage',
                component: () => import("@/components/AdministrationPage.vue")
            },
            {
				path: '/news-detail/:localId', // 修改参数名
				name: 'NewsDetail',
				component: () => import("@/components/NewsDetail.vue"),
				props: true 
			},
            {
                path: '/sc-detail/:localId',
                name: 'ScDetail',
                component: () => import("@/components/NewsDetail.vue"),
                // 利用函数式 props，把 type 和 localId 一起隐式注入到组件的 $route.query 假象中
                props: route => {
                    // 强行把 type 塞进当前路由对象的 query 里，瞒天过海
                    route.query.type = 2;
                    return { localId: route.params.localId };
                }
            },
            {
                path: '/event-detail/:localId',
                name: 'EventDetail',
                component: () => import("@/components/NewsDetail.vue"),
                props: route => {
                    route.query.type = 3; // 强行注入 type = 3
                    return { localId: route.params.localId };
                }
            },
            {
                path: '/RulesPage',
                name: 'RulesPage',
                component: () => import("@/components/RulesPage.vue")
            },
            {
                path: '/RegistrationPage',
                name: 'RegistrationPage',
                component: () => import("@/components/RegistrationPage.vue")
            },
            {
                path: '/OrganizationPage',
                name: 'OrganizationPage',
                component: () => import("@/components/OrganizationPage.vue")
            },
            {
                path: '/DirectorPage',
                name: 'DirectorPage',
                component: () => import("@/components/DirectorPage.vue")
            },
            {
                path: '/DJpublicize',
                name: 'DJpublicize',
                component: () => import("@/components/DJpublicize.vue")
            },
            {
                path: '/DJeduPage',
                name: 'DJeduPage',
                component: () => import("@/components/DJeduPage.vue")
            },
            {
                path: '/DJDetail/:newsId',
                name: 'DJDetail',
                component: () => import("@/components/DJDetail.vue"),
                props: true // 允许通过路由传递props
            },
            {
                path: '/XHMienPage',
                name: 'XHMienPage',
                component: () => import("@/components/XHMienPage")
            },
			{
				path: '/dept/:id', // :id 是动态部分，比如 /dept/InternationalPage
				name: 'DepartmentDetail',
				component: () => import('@/views/DepartmentDetail.vue')
			},
            {
                path: '/RegisterPage',
                name: 'RegisterPage',
                component: () => import("@/views/RegisterPage")
            },
        ]
    },
    // {
    //     path: '/RegisterPage',
    //     name: 'RegisterPage',
    //     component: () => import("@/views/RegisterPage")
    // },
    {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: () => import("@/views/forgetPassword")
    },
    {
        path: '/backMainScreen',
        name: 'backMainScreen',
        component: () => import("@/views/backgroundManagementSystem/backMainScreen"),
        redirect:'/backhome',
        meta: { requiresAuth: true ,roles: ['管理员', '会员', '财务', '会长', '秘书长', '执行秘书长']},
        children: [
            {
                path: '/pendingApproval',
                name: 'pendingApproval',
                component: () => import("@/views/backgroundManagementSystem/pendingApproval"),
                meta: { requiresAuth: true  ,roles: ['管理员', '秘书长', '会长', '执行秘书长'],title: '待审批'},
            }
            ,
            {
                path: '/alreadyAudit',
                name: 'alreadyAudit',
                component: () => import("@/views/backgroundManagementSystem/alreadyAudit"),
                meta: { requiresAuth: true  ,roles: ['管理员', '秘书长', '会长' , '执行秘书长'],title: '已审批'},
            }
            ,
            {
                path: '/backUser',
                name: 'backUser',
                component: () => import("@/views/backgroundManagementSystem/backUser"),
                meta: { requiresAuth: true ,roles: ['管理员', '秘书长', '会长', '执行秘书长'], title: '角色管理'},
            }
            ,
            {
                path: '/backhome',
                name: 'backhome',
                component: () => import("@/views/backgroundManagementSystem/backHome"),
                meta: { requiresAuth: true ,roles: ['管理员', '会员', '财务', '会长', '秘书长', '执行秘书长'], title: '首页'},
            }
            ,
            {
                path: '/memberInfo',
                name: 'memberInfo',
                component: () => import("@/views/backgroundManagementSystem/memberInfo"),
                meta: { requiresAuth: true ,roles: ['管理员', '会员','财务', '秘书长', '会长', '执行秘书长'], title: '会员信息'},
            }
            ,
            {
                path: '/memberRegisterState',
                name: 'memberRegisterState',
                component: () => import("@/views/backgroundManagementSystem/memberRegisterState"),
                meta: { requiresAuth: true ,roles: ['会员'],title: '注册状态'},
            },
            {
                path: '/feeApproval',
                name: 'feeApproval',
                component: () => import("@/views/backgroundManagementSystem/feeApproval"),
                meta: { requiresAuth: true ,roles: ['管理员','财务', '秘书长', '会长', '执行秘书长'] ,title: '到期会员'},
            },
            {
                path: '/profeeApproval',
                name: 'profeeApproval',
                component: () => import("@/views/backgroundManagementSystem/profeeApproval"),
                meta: { requiresAuth: true ,roles: ['管理员','财务', '秘书长', '会长', '执行秘书长'] ,title: '即将到期会员'},
            },
            {
                path: '/registerMember',
                name: 'registerMember',
                component: () => import("@/views/backgroundManagementSystem/registerMember"),
                meta: { requiresAuth: true ,roles: ['管理员','财务', '秘书长', '会长', '执行秘书长'] ,title: '注册会员'},
            },
            {
                path: '/recordMember',
                name: 'recordMember',
                component: () => import("@/views/backgroundManagementSystem/recordMember"),
                meta: { requiresAuth: true ,roles: ['管理员','财务', '秘书长', '会长', '执行秘书长'] ,title: '备案会员'},
            },
            {
                path: '/councilMember',
                name: 'councilMember',
                component: () => import("@/views/backgroundManagementSystem/councilMember"),
                meta: { requiresAuth: true ,roles: ['管理员','财务', '秘书长', '会长', '执行秘书长'] ,title: '理事会会员'},
            },
            {
                path: '/chapterMember',
                name: 'chapterMember',
                component: () => import("@/views/backgroundManagementSystem/chapterMember"),
                meta: { requiresAuth: true ,roles: ['管理员','财务', '秘书长', '会长', '执行秘书长'] ,title: '分会会员'},
            },
            {
                path: '/continueFee',
                name: 'continueFee',
                component: () => import("@/views/backgroundManagementSystem/continueFee"),
                meta: { requiresAuth: true ,roles: ['会员'] ,title: '分会会员'},
            },
            {
                path: '/changePassword',
                name: 'changePassword',
                component: () => import("@/views/backgroundManagementSystem/changePassword"),
            },
            {
                path: '/manageUser',
                name: 'manageUser',
                component: () => import("@/views/backgroundManagementSystem/manageUser"),
                meta: {title: '管理者角色'},

            },
            {
                path: '/memberUser',
                name: 'memberUser',
                component: () => import("@/views/backgroundManagementSystem/memberUser"),
                meta: {title: '普通会员角色'},
            },
            {
                path: '/feeManage',
                name: 'feeManage',
                component: () => import("@/views/backgroundManagementSystem/feeManage"),
                meta: { requiresAuth: true ,roles: ['管理员','财务','秘书长', '会长', '执行秘书长'] ,title: '会费设置'},
            },
            {
                path: '/procontinueFee',
                name: 'procontinueFee',
                component: () => import("@/views/backgroundManagementSystem/procontinueFee"),
            },
            {
                path: '/editContent',
                name: 'editContent',
                component: () => import("@/views/backgroundManagementSystem/editContent"),
                meta: { requiresAuth: true ,roles: ['管理员', '执行秘书长','秘书长', '会长'],title: '子页面内容编辑'},
            },
            {
                path: '/editImage',
                name: 'editImage',
                component: () => import("@/views/backgroundManagementSystem/editImage"),
                meta: { requiresAuth: true ,roles: ['管理员', '执行秘书长','秘书长', '会长'],title: '轮播图编辑'},
            },
            {
                path: '/editMien',
                name: 'editMien',
                component: () => import("@/views/backgroundManagementSystem/editMien"),
                meta: { requiresAuth: true ,roles: ['管理员', '执行秘书长','秘书长', '会长'],title: '各分会活动编辑'},
            },
            {
                path: '/editVideo',
                name: 'editVideo',
                component: () => import("@/views/backgroundManagementSystem/editVideo"),
                meta: { requiresAuth: true ,roles: ['管理员', '执行秘书长','秘书长', '会长'],title: '视频号编辑'},
            },
            {
                path: '/editNews',
                name: 'editNews',
                component: () => import("@/views/backgroundManagementSystem/editNews"),
                meta: { requiresAuth: true ,roles: ['管理员', '执行秘书长','秘书长', '会长'],title: '企业资讯编辑'},
            },
            // 专委会编辑
            {
                path: '/editCommittee',
                name: 'editCommittee',
                component: () => import("@/views/backgroundManagementSystem/editNews"),
                meta: { roles: ['管理员', '执行秘书长','秘书长', '会长'], title: '专委会管理', type: 2 }, // 传入 type=2
            },
            // 活动编辑
            {
                path: '/editEvent',
                name: 'editEvent',
                component: () => import("@/views/backgroundManagementSystem/editNews"),
                meta: { roles: ['管理员', '执行秘书长','秘书长', '会长'], title: '活动管理', type: 3 }, // 传入 type=3
            },
            {
                path: '/typeManage',
                name: 'typeManage',
                component: () => import("@/views/backgroundManagementSystem/typeManage"),
                meta: { requiresAuth: true ,roles: ['管理员', '执行秘书长','秘书长', '会长'],title: '行业种类设置'},
            },
            {
                path: '/upFile',
                name: 'upFile',
                component: () => import("@/views/backgroundManagementSystem/upFile"),
                meta: { requiresAuth: true ,roles: ['管理员', '执行秘书长','秘书长', '会长'],title: '文件上传'},
            },
            {
                path: '/editDJpublicize',
                name: 'editDJpublicize',
                component: () => import("@/views/backgroundManagementSystem/editDJpublicize"),
                meta: { requiresAuth: true ,roles: ['管理员', '执行秘书长','秘书长', '会长'],title: '党建宣传活动编辑'},
            },
            {
                path: '/editXHMien',
                name: 'editXHMien',
                component: () => import("@/views/backgroundManagementSystem/editXHMien"),
                meta: { requiresAuth: true ,roles: ['管理员', '执行秘书长','秘书长', '会长'],title: '协会活动编辑'},
            },
			{
				path: '/editSc',
				name: 'editSc',
				component: () => import("@/views/backgroundManagementSystem/editNews"), // 直接复用 editNews
				meta: { 
					requiresAuth: true, 
					roles: ['管理员', '执行秘书长','秘书长', '会长'], 
					title: '专委会介绍编辑' 
				},
			}
        ]
    },

    {
        path: '/backRegister',
        name: 'backRegister',
        component: () => import("@/views/backgroundManagementSystem/backRegister")
    },
    {
        path: '/backlogin',
        name: 'backlogin',
        component: () => import("@/views/backgroundManagementSystem/backLogin")
    }
	

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next)=>{
    const token = localStorage.getItem("amsystem-user")
    const user = JSON.parse(token || '{}')
    if (to.meta.title) {
        store.dispatch('updatePageTitle', to.meta.title);
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!token) {
            alert("请登录")
            next({ name: 'backlogin' })
        } else {
            if (to.matched.some(record => record.meta.roles && !record.meta.roles.includes(user.role))) {
                alert("没有权限")
                next({name: 'backhome'})
            } else {
                next()
            }
        }
    } else {
        next()
    }


})

export default router
